export default "__VITE_ASSET__Du7kDa2B__"